var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLevelBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.287 16.577L28 1.155l26.713 15.422v30.846L28 62.845 1.287 47.423V16.577z",
    fill: "#2E303C",
    stroke: "url(#levelBackground_svg__paint0_linear_1857_6945)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "levelBackground_svg__paint0_linear_1857_6945",
    x1: 28,
    y1: -3.556,
    x2: 28,
    y2: 67.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })))));
}

export default SvgLevelBackground;